<template>
  <div class="absolute bottom-0 left-0 top-0 z-10 m-2 flex">
    <div
      class="flex flex-col items-start gap-3 rounded bg-s-900/60 p-3 text-xl font-bold text-white backdrop-blur-sm"
    >
      <Icon :name="selectedLabel.icon" class="h-5 w-4 text-white" />
      <span class="text-center">
        {{ dateReport }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Icon from '~/components/common/Icon.vue'

const props = withDefaults(
  defineProps<{
    dateReport?: string
    type: 'mp4' | 'pdf' | 'xlsx' | 'in-person' | 'featured-price-analysis'
  }>(),
  {
    dateReport: '',
  },
)

const labels = {
  mp4: {
    icon: 'file-mp4',
    iconColor: '#fff',
    text: 'MP4',
  },
  pdf: {
    icon: 'file-pdf',
    iconColor: '#fff',
    text: 'PDF',
  },
  xlsx: {
    icon: 'file-xlsx',
    iconColor: '#fff',
    text: 'XLSX',
  },
  'in-person': {
    icon: 'in-person',
    iconColor: '#fff',
    text: 'In Person',
  },
  'featured-price-analysis': {
    icon: 'stars',
    iconColor: '#FDBD00',
    text: 'Featured - Price Analysis',
  },
}

const selectedLabel = computed(() => {
  return labels[props.type] || { icon: '', iconColor: '', text: '' }
})
</script>
